<template>
  <NFCWriterComp />
</template>

<script>

import NFCWriterComp from '../components/NFCWriter.vue'

  export default {
    name: 'NFCWriter',
    components: {
        NFCWriterComp,
    },
  }
</script>
